import { useRef } from 'react';
import { devError } from '@ecom-zform/shared';
/**
 * 当表单节点变更时进行报错
 */
export function useChangeFormError(form, componentName) {
    var cacheForm = useRef(form.uuid);
    devError(cacheForm.current === form.uuid, componentName, '表单节点不支持变更', form);
}
